"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignageLogItemSchema = exports.SignageLogItemBaseSchema = void 0;
const zod_extensions_1 = require("@reachmedianetwork/zod-extensions");
const logStatement_1 = require("./logStatement");
const signageBootstrap_1 = require("./signageBootstrap");
const signageLogLevel_1 = require("./signageLogLevel");
const signageMainFrameCrash_1 = require("./signageMainFrameCrash");
const signagePlayEvent_1 = require("./signagePlayEvent");
const LogStatementLogItemSchema = zod_extensions_1.z.object({
    code: zod_extensions_1.z.literal('LOG_STATEMENT'),
    data: logStatement_1.LogStatementSchema,
});
const SignageBootstapLogItemSchema = zod_extensions_1.z.object({
    code: zod_extensions_1.z.literal('SIGNAGE_BOOTSTRAP'),
    data: signageBootstrap_1.SignageBootstrapSchema,
});
const SignagePlayEventLogItemSchema = zod_extensions_1.z.object({
    code: zod_extensions_1.z.literal('SIGNAGE_PLAY_EVENT'),
    data: signagePlayEvent_1.SignagePlayEventSchema,
});
const SignageMainFrameCrashLogItemSchema = zod_extensions_1.z.object({
    code: zod_extensions_1.z.literal('SIGNAGE_MAIN_FRAME_CRASH'),
    data: signageMainFrameCrash_1.SignageMainFrameCrashSchema,
});
exports.SignageLogItemBaseSchema = zod_extensions_1.z.object({
    category: zod_extensions_1.z.string(),
    id: zod_extensions_1.z.string(),
    level: zod_extensions_1.z.nativeEnum(signageLogLevel_1.SignageLogLevel),
    message: zod_extensions_1.z.string(),
    subcategory: zod_extensions_1.z.string(),
    time: zod_extensions_1.z.number(),
});
exports.SignageLogItemSchema = zod_extensions_1.z.union([
    exports.SignageLogItemBaseSchema.and(LogStatementLogItemSchema),
    exports.SignageLogItemBaseSchema.and(SignageBootstapLogItemSchema),
    exports.SignageLogItemBaseSchema.and(SignagePlayEventLogItemSchema),
    exports.SignageLogItemBaseSchema.and(SignageMainFrameCrashLogItemSchema),
]);
//# sourceMappingURL=signageLogItem.js.map